import { render, staticRenderFns } from "./CreditItem.vue?vue&type=template&id=f9bdbd0e&scoped=true&"
import script from "./CreditItem.vue?vue&type=script&lang=js&"
export * from "./CreditItem.vue?vue&type=script&lang=js&"
import style0 from "./CreditItem.vue?vue&type=style&index=0&id=f9bdbd0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bdbd0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
